import { render } from "./TemplateType.vue?vue&type=template&id=52ffae48&ts=true"
import script from "./TemplateType.vue?vue&type=script&lang=ts"
export * from "./TemplateType.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__